module.exports = __webpack_public_path__ + "static/media/skull.87667750.svg";